
<NoteBox class="mb-24" header="Rate tip">
  <div v-if="childCare && !payRateFetchError" class="flex justify-between mt-4">
    <p class="text-body-2">What sitters like you charge</p>
    <p class="text-body-2 font-medium" aria-hidden="true">${{ payRange.min }}-{{ payRange.max }}/hr</p>
    <p class="text-body-2 font-medium sr-only">{{ payRange.min }} to {{ payRange.max }} dollars per hour</p>
  </div>
  <div v-else class="mt-4">
    <p class="text-body-2" aria-hidden="true">The average range near you is $20-23/hr</p>
    <p class="text-body-2 sr-only">The average range near you is 20 to 23 dollars per hour</p>
  </div>
</NoteBox>
